<div class="btn-group float-right ml-2" role="group">
  <button id="btnExportarListagem" type="button" class="btn btn-sm btn-outline-secondary dropdown-toggle"
    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
    Exportar
  </button>
  <div class="dropdown-menu" aria-labelledby="btnExportarListagem">
    <a (click)="exportar('pdf')" class="dropdown-item btn btn-sm btn-outline-secondary"
      style="display: contents;">
      <img src="assets/img/global/pdf.png" alt="pdf" title="Gerar pdf" height="32" width="32" style="margin: 10px">
    </a>
    <a (click)="exportar('xlsx')" class="dropdown-item btn btn-sm btn-outline-secondary"
      style="display: contents;">
      <img src="assets/img/global/xls.png" alt="xlsx" title="Gerar xlsx" height="32" width="32" style="margin: 10px">
    </a>
    <a (click)="exportar('xml')" class="dropdown-item btn btn-sm btn-outline-secondary"
      style="display: contents;">
      <img src="assets/img/global/xml.png" alt="xml" title="Gerar xml" height="32" width="32" style="margin: 10px">
    </a>
    <a (click)="exportar('csv')" class="dropdown-item btn btn-sm btn-outline-secondary"
      style="display: contents;">
      <img src="assets/img/global/csv.png" alt="csv" title="Gerar csv" height="32" width="32" style="margin: 10px">
    </a>
    <a (click)="exportar('docx')" class="dropdown-item btn btn-sm btn-outline-secondary"
      style="display: contents;">
      <img src="assets/img/global/doc.png" alt="docx" title="Gerar docx" height="32" width="32" style="margin: 10px">
    </a>
    <a (click)="exportar('JSON')" class="dropdown-item btn btn-sm btn-outline-secondary"
      style="display: contents;">
      <img src="assets/img/global/js.png" alt="json" title="Gerar json" height="32" width="32" style="margin: 10px">
    </a>
  </div>
</div>